import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69e51e818485e200144368cd/tunisiapadel/src/app/sign-up-login/components/AuthPanel.tsx");
